import React from "react";

import MenuFabric from "../MenuFabric";
import PDFPrinter from "../PDFPrinter";

import "./styles.css";

const ControlPanel = props => {
  const {
    file,
    pageNumber,
    numPages,
    setPageNumber,
    scale,
    setScale,
    pageScroll,
    showNav,
    setShowNav,
    setDropdownPencil,
    showDropdownPencil
  } = props;

  const isFirstPage = pageNumber === 1;
  const isLastPage = pageNumber === numPages;

  const firstPageClass = isFirstPage ? "disabled" : "clickable";
  const lastPageClass = isLastPage ? "disabled" : "clickable";

  const goToFirstPage = () => {
    if (!isFirstPage) {
      setPageNumber(1);
    }
  };
  const goToPreviousPage = () => {
    if (!isFirstPage && pageNumber) {
      setPageNumber(pageNumber - 1);
    }
  };
  const goToNextPage = () => {
    if (!isLastPage) {
      setPageNumber(pageNumber + 1);
    }
  };
  const goToLastPage = () => {
    if (!isLastPage) {
      setPageNumber(numPages);
    }
  };

  const onPageChange = e => {
    const { value } = e.target;

    if (Number(value) <= numPages && Number(value) >= 0) {
      setPageNumber(Number(value));
    }
  };

  const isMinZoom = scale < 0.6;
  const isMaxZoom = scale >= 2.0;

  const zoomOutClass = isMinZoom ? "disabled" : "clickable";
  const zoomInClass = isMaxZoom ? "disabled" : "clickable";

  const zoomOut = () => {
    if (!isMinZoom) setScale(scale - 0.1);
  };

  const zoomIn = () => {
    if (!isMaxZoom) setScale(scale + 0.1);
  };

  return (
    <div className="control-panel mb-3 p-3 px-4 d-flex align-items-center justify-content-between">
      <div>
        <i
          className="fa fa-bars"
          id="hamburguer"
          onClick={() => setShowNav(!showNav)}
        />
      </div>
      <div className="d-flex justify-content-between">
        <div className="d-flex justify-content-between align-items-baseline">
          <i
            className={`fa fa-search-minus mx-3 ${zoomOutClass}`}
            onClick={zoomOut}
          />
          <span>{(scale * 100).toFixed()}%</span>
          <i
            className={`fa fa-search-plus mx-3 ${zoomInClass}`}
            onClick={zoomIn}
          />
        </div>
        {/* Aqui DOWNLOAD */}
        {props.enableSave && (
          <div className="mx-2">
            <a href={file} download title="download">
              <i className="fa fa-download clickable" />
            </a>
          </div>
        )}
        {props.enablePrint && (
          <div className="mx-2">
            <PDFPrinter file={file} />
          </div>
        )}

        <div className="d-flex justify-content-between align-items-baseline">
          <i
            className={`fa fa-fast-backward ml-3 mr-2 ${firstPageClass}`}
            onClick={goToFirstPage}
          />
          <i
            className={`fa fa-backward mx-3 ${firstPageClass}`}
            onClick={goToPreviousPage}
          />
          <span>
            Página{" "}
            <input
              name="pageNumber"
              type="number"
              min={1}
              max={numPages || 1}
              value={pageNumber || ""}
              className="p-0 pl-1 mx-2"
              onChange={onPageChange}
              onFocus={e => e.target.select()}
            />{" "}
            de {numPages}
          </span>
          <i
            className={`fa fa-forward mx-3 ${lastPageClass}`}
            onClick={goToNextPage}
          />
          <i
            className={`fa fa-fast-forward ml-2 mr-3 ${lastPageClass}`}
            onClick={goToLastPage}
          />
        </div>
        <MenuFabric
          editor={props.editor}
          activeRectangle={props.activeRectangle}
          setActiveRectangle={props.setActiveRectangle}
          activePencil={props.activePencil}
          setActivePencil={props.setActivePencil}
          cursorState={props.cursorState}
          setCursorState={props.setCursorState}
          textFlag={props.textFlag}
          addTextEnabled={props.addTextEnabled}
          rectFlag={props.rectFlag}
          rectFunctions={props.rectFunctions}
          setCanvasHeight={props.setCanvasHeight}
          setDropdownPencil={props.setDropdownPencil}
          showDropdownPencil={props.showDropdownPencil}
          previousState={props.previousState}
          nextState={props.nextState}
        />
      </div>

      <div>{/* <FiHelpCircle onClick={() => {}} id="help" /> */}</div>
    </div>
  );
};

export default ControlPanel;
